import { createSelector } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map, takeUntil } from 'rxjs/operators';

import { BaseAsyncValue } from '@ordersnproducts/modules/shared/models/async-value';
import { SpecFieldNames } from '@ordersnproducts/modules/order-builder/modules/specification/constants/specification-field-names.enum';
import { AddedValueFieldConfig } from '@ordersnproducts/modules/order-builder/modules/rms-specification/models/form-added-value-field-config';
import { getRmsRehydrate } from '@ordersnproducts/modules/order-builder/modules/rms-specification/selectors/index';
import { getAvailableOpenPlatformAddedValues } from '@ordersnproducts/modules/order-builder/modules/rms-specification/selectors/added-value.selectors';
import { _safe } from '@ordersnproducts/modules/shared/utils/safe-get.method';

const addedValueAndRehydrate = createSelector(
  getAvailableOpenPlatformAddedValues,
  getRmsRehydrate,
  (availables, rehydate) => {
    return {
      availables,
      rehydate,
    };
  },
);

export namespace AddedValueOpenPlatformDisabler {
  export class IsLoading extends BaseAsyncValue<Boolean> {
    getValue(): Observable<Boolean> {
      return this.store.select(addedValueAndRehydrate).pipe(
        takeUntil(this.ngDestroy),
        map(({ availables }) => {
          const keyName = `${_safe(() => this.form.get(SpecFieldNames.CONTRACT_SELECT).value)}_${
            this.form.get(SpecFieldNames.ID).value
          }`;
          return availables[keyName];
        }),
        map(state => {
          if (state) {
            const index = (this.config as AddedValueFieldConfig).index;
            if (state[index]) {
              if (state[index].addedValues === null) {
                return true;
              } else {
                if (state[index].loading === false) {
                  // If there are 0 added values, then disable (return true)
                  if (state[index].addedValues.length) {
                    return false;
                  } else {
                    return true;
                  }
                  // End if for added values length checking
                } else {
                  return true;
                }
              }
            } else {
              return true;
            }
          } else {
            return true;
          }
        }),
      );
    }
  }
}
